import { combineReducers } from "redux";
import invoiceRowReducer from "./invoice-reducers/add-order-reducer";
import bulkPurchaseReducer from "./purchase-sec-reducer.js/bulk-purchasee-reducer";
import picklistReducer from "./picklist-reducer";

const rootReducer = combineReducers({
  invoiceRowReducer,
  bulkPurchaseReducer,
  picklistReducer,
});

export default rootReducer;
